import React from 'react';
import {
  Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from '@/components/ui/tooltip';

/**
 * 24h uptime SLA chip. Reuses the emerald/amber/rose palette from the
 * status pill so the card header stays visually consistent.
 *
 *   >= 99%    emerald
 *   95-98.99  amber
 *   < 95%     rose
 *   null      neutral gray "Insufficient data" (< 6h of samples)
 */
const chipColor = (pct) => {
  if (pct == null) return 'bg-neutral-100 text-neutral-600 border-neutral-200';
  if (pct >= 99) return 'bg-emerald-50 text-emerald-800 border-emerald-200';
  if (pct >= 95) return 'bg-amber-50 text-amber-800 border-amber-200';
  return 'bg-rose-50 text-rose-800 border-rose-200';
};

export const UptimeSlaChip = ({ integration, testId }) => {
  if (!integration) return null;
  const pct = integration.uptime_pct;
  const insufficient = pct == null;
  const label = insufficient ? '24h: Insufficient data' : `24h: ${pct.toFixed(1)}%`;
  const tooltip = insufficient
    ? 'Fewer than 6h of samples collected. Uptime available once 12+ buckets have data.'
    : 'Uptime last 24h. OK buckets weighted 1.0, warning 0.5, error 0.0.';
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold cursor-default ${chipColor(pct)}`}
            data-testid={testId}
          >
            {label}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="text-[11px]">
          {tooltip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default UptimeSlaChip;
